// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false, 
  //apiURL: "http://localhost:3005/api/v1/", // Use this for Local API
  // apiURL: "https://aoc-api-qa.borderlessaccess.com/api/v1/", // Use this for Stage API
  apiURL: "https://aoc-api.borderlessaccess.com/api/v1/", // Use this for PROD API
  ImagePath : "https://aoc.borderlessaccess.com",
  //ImagePath : "http://localhost:4200",
  CommentsMaxLimit: 20
};